/*
Wrapper for paper-textarea.
paper-textarea crashes on iOS when created programmatically. This only impacts
our automation and script editors as they are using Preact. Polymer is using
template elements and does not have this issue.
paper-textarea issue: https://github.com/PolymerElements/paper-input/issues/556
WebKit issue: https://bugs.webkit.org/show_bug.cgi?id=174629
*/

import '@polymer/paper-input/paper-textarea.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';

class CbarTextarea extends PolymerElement {
  static get template() {
    return html`
      <style>
        :host {
          display: block;
        }
      </style>
      <paper-textarea
        label='[[label]]'
        value='{{value}}'
        rows$='[[rows]]'
        max-rows$='[[maxRows]]'
        name="[[name]]"
      ></paper-textarea>
    `;
  }

  static get properties() {
    return {
      label: String,
      name: String,

      value: {
        type: String,
        notify: true,
      },

      /**
       * The initial number of rows.
       * @type {number}
       * @default 1
       */
      rows: {
        type: Number,
        value: 1,
      },

      /**
       * The maximum number of rows this element can grow to until it
       * scrolls. 0 means no maximum.
       * @type {number}
       * @default 0
       */
      maxRows: {
        type: Number,
        value: 0,
      },
    };
  }
}

customElements.define('cbar-textarea', CbarTextarea);

